import React from 'react';
import { useSwipeable, LEFT, RIGHT, UP, DOWN } from 'react-swipeable';

import { swipeDirections, swipeConfig, SWIPED_DELTA } from './constant';
import { useStyles } from './useStyles';

const initialState = { dragX: 0, dragY: 0, swiping: false };

export const Swipeable = React.memo(({ draggable, maxDragShift, swipeDirection, onSwiped, onSwiping, className, ...props }) => {
    const [state, setState] = React.useState(initialState);
    const [isSwiping, setIsSwiping] = React.useState(false);
    const classes = useStyles();

    const handleSwipeStart = React.useCallback(
        (SwipeEventData) => {
            const direction = swipeDirections[SwipeEventData.dir.toUpperCase()];

            if (draggable && swipeDirection && direction & swipeDirection) {
                setState((prevState) => ({
                    ...prevState,
                    swiping: true,
                }));

                setIsSwiping(true);
            }
        },
        [draggable, swipeDirection]
    );

    const handleSwiping = React.useCallback(
        (SwipeEventData) => {
            const direction = swipeDirections[SwipeEventData.dir.toUpperCase()];

            if (draggable && state.swiping && direction & swipeDirection) {
                if (
                    (SwipeEventData.dir === LEFT || SwipeEventData.dir === RIGHT) &&
                    (!maxDragShift || (maxDragShift && SwipeEventData.absX <= maxDragShift))
                ) {
                    setState((prevState) => ({
                        ...prevState,
                        dragX: SwipeEventData.deltaX,
                    }));
                } else if (
                    (SwipeEventData.dir === UP || SwipeEventData.dir === DOWN) &&
                    (!maxDragShift || SwipeEventData.absY <= maxDragShift)
                ) {
                    setState((prevState) => ({
                        ...prevState,
                        dragY: SwipeEventData.deltaY,
                    }));
                }
            }

            if (onSwiping) {
                onSwiping(SwipeEventData);
            }
        },
        [draggable, state.swiping, maxDragShift, onSwiping]
    );

    const handleSwiped = React.useCallback(
        (SwipeEventData) => {
            if (onSwiped && isSwiping && Math.max(SwipeEventData.absX, SwipeEventData.absY) >= SWIPED_DELTA) {
                const direction = swipeDirections[SwipeEventData.dir.toUpperCase()];

                if (!swipeDirection || direction & swipeDirection) {
                    onSwiped(SwipeEventData);
                }
            }

            setIsSwiping(false);
        },
        [isSwiping, swipeDirection, onSwiped]
    );

    const handleTouchEnd = React.useCallback(() => {
        setState(initialState);
    }, []);

    const handlers = useSwipeable({
        onSwiped: !swipeDirection ? handleSwiped : null,
        onSwipedLeft: swipeDirection & swipeDirections.LEFT ? handleSwiped : null,
        onSwipedRight: swipeDirection & swipeDirections.RIGHT ? handleSwiped : null,
        onSwipedUp: swipeDirection & swipeDirections.UP ? handleSwiped : null,
        onSwipedDown: swipeDirection & swipeDirections.DOWN ? handleSwiped : null,
        onSwipeStart: handleSwipeStart,
        onSwiping: handleSwiping,
        onTouchEndOrOnMouseUp: handleTouchEnd,
        ...swipeConfig,
    });

    return (
        <div className={classes.wraper}>
            <div
                className={className}
                style={{
                    transform: `translateX(${state.dragX}px) translateY(${state.dragY}px)`,
                    transition: '0.2s ease',
                }}
                {...handlers}
            >
                {props.children}
            </div>
        </div>
    );
});
